import { createSlice } from "@reduxjs/toolkit";
import * as reducers from "./calculatorReducers";
import { CalculatorPageState } from "./models/CalculatorPageState";
import { extraReducers } from "./calculatorExtraReducers";

export const initialState: CalculatorPageState = {
  form: {
    loadingFinancingStructure: false,
    loadingPeriodFee: false,
    dirty: false,
  },
  isLoaded: false,
  isCompleted: false,
};

export const calculatorSlice = createSlice({
  name: "calculator",
  initialState,
  reducers,
  extraReducers,
});

export const { loadPage, updateForm, validateForm, resetCalculatedValues, setPeriodFeeLoading, complete } = calculatorSlice.actions;

export default calculatorSlice.reducer;
